import * as yup from 'yup';
import { strongPasswordSchema } from '@common/schema';

export const resetPasswordSchema = yup.object().shape({
  password: strongPasswordSchema,
  confirm: yup.string().oneOf([yup.ref('password')], 'Passwords must match'),
});
